import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Nothing here yet.", subtitle, icon: Icon = Inbox }) {
  return (
    <div className="empty">
      <Icon size={22} />
      <div>{title}</div>
      {subtitle ? <div style={{ marginTop: 4, fontSize: 11 }}>{subtitle}</div> : null}
    </div>
  );
}
